import React from "react";
import { useSelector } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";
import DNVSpinner from "../components/DNVSpinner";
import { InitVM, SubscriptionLevel } from "../autogenerated/models";
import { ApplicationState } from "../store";

import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface MainLayoutProps {
  children: React.ReactNode;
}

const isAuthenticated = (user: InitVM["user"]) => !!user?.id;

const MainLayout = ({ children }: MainLayoutProps) => {
  const { data } = useSelector((state: ApplicationState) => state.init);

  let routes = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "CIMbion Conformance Testing",
      path: "/cimbion-conformance-testing",
    },
    {
      name: "CIMbion unSHACLed",
      path: "/cimbion-unshacled",
    },
  ];

  if (data && data.user?.roles?.some((role) => role === "Consultant")) {
    routes.push({
      name: "Users",
      path: "/users",
    });
  }

  return (
    <div className="mainLayout">
      {!data || !isAuthenticated(data.user) ? (
        <DNVSpinner land={true} sea={true} air={true} />
      ) : (
        <>
          <Header
            routes={routes}
            appName="CIMbion"
            name={data.user?.name || ""}
            subscription={data.user?.subscription ?? SubscriptionLevel.None}
            unshacledSubscription={data.user?.unshacledSubscription}
          />
          <p style={{ display: "none" }}>
            {"Version: " + (!!data ? data.appVersion : "")}
          </p>
          <ToastContainer
            position="top-right"
            transition={Slide}
            autoClose={5000}
            hideProgressBar
            theme="colored"
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable={false}
            pauseOnFocusLoss
            style={{ wordBreak: "break-word" }}
          />
          <div className="pageContent">{children}</div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default MainLayout;
